import { render } from "./ManageCors.vue?vue&type=template&id=743e49e9"
import script from "./ManageCors.vue?vue&type=script&lang=js"
export * from "./ManageCors.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__